<template>
	<div class="personal-collect">
		<template v-for="item in collectList">
			<item-block :itemContent="item" ></item-block>
		</template>
	</div>
</template>
<script>
	import ItemBlock from "../../components/ItemBlock"
	import {PersoanalAttention} from '../../config/interface.js'
	export default{
		components:{
			ItemBlock
		},
		data(){
			return{
				collectList:[],   //收藏列表
			}
		},
		mounted(){
			this.init();
		},
		methods:{
			//初始化
			init(){
				const url=PersoanalAttention;
				let params={};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						data.articles.forEach((item,index)=>{
							this.collectList.push(item);
						})
					}
				})
			},			
		}
	}
</script>
<style lang="scss">
	.personal-collect{
		padding:14px 12px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/personal/MyCollect.vue